<div
  fxLayout
  *ngIf="{
    connectedAccounts: connectedAccounts$ | async,
    unmatchedDevices: unmatchedDevices$ | async,
    hasWriteAccess: hasWriteAccess$ | async
  } as vm">
  <sbnb-subnav fxFlex="280px" fxHide.lt-md header="Devices">
    <sbnb-devices-subnav></sbnb-devices-subnav>
  </sbnb-subnav>

  <main fxFlex class="subnav__exists page-device-setup" [ngClass.lt-md]="{ mobile: true, subnav__exists: false }">
    <sbnb-content-header
      title="Connect Devices"
      [saveButtonShown]="false"
      [sticky]="false"
      novaContentId="smart-devices-dashboard"></sbnb-content-header>

    <section class="connect-new-device-container">
      <h3>Connect a Device Account</h3>
      <p>We currently support the following smart devices:</p>
      <p>
        <span class="font-bold text-black">Smart Locks:</span>
        Schlage, August, Yale, SmartThings, Nuki, Igloo, and TTLock.
      </p>
      <p>
        <span class="font-bold text-black">Thermostats:</span>
        Honeywell, Ecobee.
      </p>

      <sbnb-device-upsell-button>
        <sbnb-button
          *sbnbDeviceUpsellButtonContent
          [matTooltip]="!vm.hasWriteAccess ? 'You do not have permission to connect a device account' : null"
          [disabled]="!vm.hasWriteAccess"
          [loading]="loadingConnectionUrl"
          (clicked)="onConnectDeviceAccountClicked()">
          Connect
        </sbnb-button>
      </sbnb-device-upsell-button>
    </section>

    <mat-tab-group class="setup-tabs">
      <mat-tab
        label="Connected Accounts {{
          vm.connectedAccounts.data?.length ? '(' + vm.connectedAccounts.data.length + ')' : null
        }}">
        <div class="tab-body">
          <mat-spinner *ngIf="vm.connectedAccounts.loading" [diameter]="24"></mat-spinner>
          <div *ngIf="vm.connectedAccounts.error" class="error">{{ vm.connectedAccounts.error }}</div>

          <div *ngIf="vm.connectedAccounts.data?.length === 0" class="error">
            <sbnb-no-items text="No accounts found"></sbnb-no-items>
          </div>

          <sbnb-smart-device-connected-accounts-table
            *ngIf="vm.connectedAccounts.data?.length > 0"
            [accounts]="vm.connectedAccounts.data"
            [canAction]="vm.hasWriteAccess"
            (accountDeleted)="onAccountDeleted($event)"></sbnb-smart-device-connected-accounts-table>
        </div>
      </mat-tab>

      <mat-tab
        label="Unmatched Devices {{
          vm.unmatchedDevices.data?.length ? '(' + vm.unmatchedDevices.data.length + ')' : null
        }}">
        <div class="tab-body">
          <mat-spinner *ngIf="vm.unmatchedDevices.loading" [diameter]="24"></mat-spinner>
          <div *ngIf="vm.unmatchedDevices.error" class="error">{{ vm.guests.error }}</div>

          <div *ngIf="vm.unmatchedDevices.data?.length === 0" class="error">
            <sbnb-no-items text="No unmatched devices"></sbnb-no-items>
          </div>

          <sbnb-smart-device-unmatched-devices-table
            *ngIf="vm.unmatchedDevices.data?.length > 0"
            [devices]="vm.unmatchedDevices.data"
            [canAction]="vm.hasWriteAccess"
            (deviceMatched)="onDeviceMatched($event)"></sbnb-smart-device-unmatched-devices-table>
        </div>
      </mat-tab>
    </mat-tab-group>
  </main>
</div>

<sbnb-mobile-sidebar [navTabsHide]="true" title="Devices">
  <sbnb-devices-subnav></sbnb-devices-subnav>
</sbnb-mobile-sidebar>
